module.exports = __webpack_public_path__ + "img/tik-tok-icon.a624128.svg";